import {
  Box,
  Button,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { DiscoverViewContext } from "contexts/DiscoverView";
import { MetricsContext, TimeFrame } from "contexts/Metrics";
import { OrganizationUserContext } from "contexts/Organization";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext, useEffect } from "react";

import { useSubscription } from "utils/useSubscription";

import Metric from "./Metric";
import MetricsByTemplate from "./Template";
import MetricsByTier from "./Tier";
import { TimePeriod } from "./schema";
import styles from "./styles";

export default function MetricsHelper() {
  const { currentUser } = useContext(OrganizationUserContext);
  const { setDiscoverTab } = useContext(DiscoverViewContext);
  const { fetchMetrics } = useContext(MetricsContext);

  const { setUpgradeDialogSource } = useContext(SubscriptionContext);

  const { cannotUpgrade } = useSubscription();

  const closeDialog = () => {
    setDiscoverTab(null);
  };

  const firstName =
    currentUser && currentUser.name && currentUser.name.split(" ")[0];

  useEffect(() => {
    [TimePeriod.today, TimePeriod.thisWeek, TimePeriod.thisMonth].forEach(
      (period) => fetchMetrics(period),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box sx={styles.root}>
      <Grid container>
        {/* Top Bar */}
        <Grid item xs={12} sx={styles.header}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography
              variant="h6"
              sx={{ fontSize: 14, textTransform: "uppercase" }}
            >
              {firstName
                ? `${firstName}'${firstName.endsWith("s") ? "" : "s"} `
                : ""}
              Metrics
            </Typography>
            <IconButton sx={styles.close} onClick={closeDialog}>
              <Box component="i" className="fa-regular fa-xmark" />
            </IconButton>
          </Grid>
        </Grid>

        <Metric timeFrame={TimeFrame.daily} />
        <Metric timeFrame={TimeFrame.weekly} />
        <Metric timeFrame={TimeFrame.monthly} />

        <MetricsByTemplate />
        <MetricsByTier />

        {!cannotUpgrade && (
          <Grid item xs={12} sx={styles.metricsWrapper}>
            <Typography sx={{ color: "primary.main" }}>
              <strong>WANT TO LEVEL UP YOUR METRICS?</strong>
            </Typography>

            <Typography variant="body2">
              Upgrade to the Virtual Assistant plan to receive pitches that
              perform 2x better
            </Typography>

            <Button
              size="small"
              variant="contained"
              disableElevation
              sx={{ mt: 1 }}
              onClick={() => {
                setUpgradeDialogSource("Upgrade VA Button");
              }}
            >
              Upgrade
            </Button>
          </Grid>
        )}

        <Grid item xs={12} sx={{ px: 3 }}>
          <Typography sx={styles.title} paragraph>
            Bento Best Practice Framework
          </Typography>
          <Typography variant="body2">Send at least 30 emails/week</Typography>
          <Typography variant="body2">Set 1-2 follow-ups</Typography>
          <Typography variant="body2">
            Follow up if a contact opens the email multiple times
          </Typography>
          <Typography variant="body2">
            Respond to replies within 1 hour
          </Typography>
          <>
            <Typography sx={styles.title} paragraph>
              Bento Average Industry Metrics
              <Tooltip
                title={
                  "If your metrics differ greatly from these industry metrics, there may be an issue. Contact us at hello@onbento.com and we will help you troubleshoot."
                }
              >
                <Box
                  component="i"
                  sx={styles.infoIcon}
                  className="fa-regular fa-circle-info"
                />
              </Tooltip>
            </Typography>
            <Typography variant="body2">55.9% open rate</Typography>
            <Typography variant="body2" paragraph>
              9.4% response rate
            </Typography>
          </>
        </Grid>
      </Grid>
    </Box>
  );
}
